export const API_URL = "https://emp.corevisualizers.com/api/";
export const FILE_API_URL = "https://emp.corevisualizers.com/api/";
